export default __webpack_public_path__ + "static/media/chevron-left.daf73fc1.svg";